import { Box, Grid, useMediaQuery, useTheme } from '@mui/material'
import { KeyboardEvent, MouseEvent, useEffect, useRef } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { MapSection } from '../../components/MapSection'
import { UtilitySlideout } from '../../components/UtilitySlideout'
import { UtilityDetail } from '../../components/UtilitySlideout/subComponents'
import { AppActions, AppSelector } from '../../store/app'
import { MapRefProps } from './Main'
import { OverlayDesktop } from './Overlay.desktop'
import { useStyles } from '../../theme'
import { UtilityDetailSelector } from '../../store/utilityDetails'


export const MainDesktop = () => {
  const dispatch = useDispatch()
  const styles = useStyles()
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'))
  const mapRef = useRef<MapRefProps | null>(null)
  const mapContainerRef = useRef<HTMLDivElement | null>(null)
  const flyoutContainerRef = useRef<HTMLDivElement | null>(null)
  const debounceResize = useRef(null as any)

  const utilityDetailOpen = useSelector(UtilityDetailSelector.getShowDrawer)
  const utilityOpen = useSelector(AppSelector.getMapDataDrawerState)

  const onCloseUtilityDetail = (e: MouseEvent | KeyboardEvent) => {
    dispatch(AppActions.setMapDataDrawerOpen(false))
  }

  useEffect(() => {
    const observer = new ResizeObserver((entries) => {
      clearTimeout(debounceResize.current)
      const resizeEvent = new CustomEvent('mapContainerResize', { detail: entries[0].contentRect })
      debounceResize.current = setTimeout(()=>{
        window.dispatchEvent(resizeEvent)
      },150)

    })
    if (mapContainerRef.current) {
      observer.observe(mapContainerRef.current)
    }
    const mcRef = mapContainerRef.current
    return () => {
      clearTimeout(debounceResize.current)
      if (mcRef) {
        observer.unobserve(mcRef)
      }
    }
  }, [])



  return (
    <>
      <Grid
        container
        flexDirection="row"
        ref={mapContainerRef}
        sx={{ flexGrow: 1, position: 'relative' }}
      >
        <OverlayDesktop mapRefs={mapRef} />
        <MapSection ref={mapRef} />
      </Grid>
      <Grid
        container
        flexDirection="row"
        flexGrow={0}
        flexShrink={1}

        sx={{
          flexShrink: 1,
          position: 'relative',
          maxWidth: '30%',
          minWidth:'fit-content',
        }}
      >
        <Box
          height="100%"
          display="flex"
          flexDirection="column"
          ref={flyoutContainerRef}
          sx={{
            ...styles.scrollbar,
            flexShrink: 1,
            position: 'relative',
            transition: 'width 0.3s ease-in-out',
            overflow: 'hidden',
            zIndex: theme.zIndex.drawer + 99,

            width: isMobile ? '100%' : utilityOpen || utilityDetailOpen ? '35vw' : '0px',
          }}
        >
        <UtilityDetail onClose={onCloseUtilityDetail} mapRef={mapRef} />
        <UtilitySlideout mapRef={mapRef} />
        </Box>

      </Grid>
    </>
  )
}
